<template>
  <div>
    <div class="whiteBg">
      <el-button type="primary" plain icon="el-icon-plus" @click="addCourse">新增课程</el-button>
      <dy-table :columns="columns_" style="margin-top: 12px" :table-data="courseList" v-loading="tableLoading"
        :total="total" :page-num="pageNum" :page-size="10" @current-change="onCurrentChange"
        element-loading-text="加载中"></dy-table>
    </div>
    <projectContent ref="projectContent"></projectContent>
    <projectDialog ref="projectDialog" :_courseForm="courseForm" :_dialogTitle="dialogTitle" :labelList="labelList"
      @getList="getList"> </projectDialog>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import projectContent from './projectContent';
import projectDialog from './projectDialog';

import host from '@/api/index';
import { getCourseList, getCourseInfo, courseDelete, coursePublish, courseExamine } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { pushUserType, operatingSystemPhone } from '@/utils/commonData';
import { formatDate, strToArr, arrToStr } from '@/utils/utils';

export default {
  name: 'courseB',
  components: {
    DyTable,
    projectContent,
    projectDialog,
  },
  props: {
    labelList: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    uploadImg() {
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  data() {
    return {
      searchForm: {},

      columns_: [],
      courseList: [],
      tableLoading: true,
      total: 0,
      pageNum: 1,
      pageSize: 10,

      pushUserType,
      operatingSystemPhone,

      dialogTitle: '新建课程',
      courseForm: {},
    };
  },
  created() { },
  mounted() {
    this.columns_ = [
      ...this.columns,
      {
        type: 'index',
        title: '序号',
      },

      {
        key: 'id',
        title: '课程ID',
      },
      {
        key: 'courseTitle',
        title: '课程名称',
        width: 200,
        render: ({ row }) => {
          return (
            <div>
              <div>{row.courseTitle}</div>
              <div class="flex">

                <el-tooltip class="mr-5" effect="dark" content={`观看人数：${row.watchNum || 0}`} placement="top-start">
                  <div>
                    <i class="el-icon-view mr-5"></i>
                    {row.watchNum || 0}
                  </div>
                </el-tooltip>
                <el-tooltip class="mr-5" effect="dark" content={`评论人数：${row.remarkNum || 0}`} placement="top-start">
                  <div>
                    <i class="el-icon-chat-line-round mr-5"></i>
                    {row.remarkNum || 0}
                  </div>
                </el-tooltip>
                {/* <i class="el-icon-view"></i>
                <div>
                  {row.praiseNum || 0}
                </div> */}
                <el-tooltip class="mr-5" effect="dark" content={`收藏人数：${row.collectNum || 0}`} placement="top-start">
                  <div>
                    <i class="el-icon-star-off mr-5"></i>
                    {row.collectNum || 0}
                  </div>
                </el-tooltip>
                <el-tooltip class="mr-5" effect="dark" content={`分享人数：${row.shareNum || 0}`} placement="top-start">
                  <div>
                    <i class="el-icon-share mr-5"></i>
                    {row.shareNum || 0}
                  </div>
                </el-tooltip>
              </div>
            </div >
          );
        },
      },
      {
        key: 'categoryName',
        title: '课程分类',
      },
      {
        key: 'updateDate',
        title: '操作时间',
      },
      {
        key: 'bgUserName',
        title: '操作人',
      },
      {
        key: 'examineStatus',
        title: '审核状态',
        render: ({ row }) => {
          if (row.examineStatus == 0) {
            return (
              <div>
                <el-button type='warning' round size='mini'>
                  待审核
                </el-button>
              </div>
            );
          } else if (row.examineStatus == 1) {
            return (
              <div>
                <el-button type='primary' round size='mini'>
                  审核中
                </el-button>
              </div>
            );
          } else if (row.examineStatus == 2) {
            return (
              <div>
                <el-button type='success' round size='mini'>
                  审核成功
                </el-button>
              </div>
            );
          } else if (row.examineStatus == 3) {
            return (
              <div>
                <el-button type='danger' round size='mini'>
                  审核失败
                </el-button>
              </div>
            );
          }
        },
      },
      {
        key: '',
        title: '操作',
        width: 300,
        render: ({ row }) => {
          // 审核状态:0待审核,1审核中,2已审核,3审核失败
          if (row.examineStatus == 0) {
            return (
              <div>
                {/* {false && ( */}
                <el-link type='primary' onClick={() => this.doEdit(row)}>
                  编辑
                </el-link>
                {/* )} */}
                <el-link type='warning' style='margin-left:12px' onClick={() => this.subReview(row)}>
                  提交审核
                </el-link>
                <el-link type='danger' style='margin-left:12px' onClick={() => this.doDelete(row)}>
                  删除
                </el-link>
                <el-dropdown trigger='click' class='user-name'>
                  <el-link type='primary' style='margin-left:12px'>
                    更多
                  </el-link>
                  <el-dropdown-menu slot='dropdown'>
                    <el-dropdown-item>
                      <span onClick={() => this.contDialogOpen(row)}>课程内容</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <span onClick={() => this.coursePreview(row)}>课程预览</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            );
          } else if (row.examineStatus == 1) {
            return (
              <div>
                <el-link type='primary' style='margin-left:12px' onClick={() => this.coursePreview(row)}>
                  课程预览
                </el-link>
              </div>
            );
          } else if (row.examineStatus == 2) {
            return (
              <div>
                <el-link type='primary' onClick={() => this.doEdit(row)}>
                  编辑
                </el-link>
                <el-link type='warning' style='margin-left:12px' onClick={() => this.coursePublish(row)}>
                  发布
                </el-link>
                <el-link type='danger' style='margin-left:12px' onClick={() => this.doDelete(row)}>
                  删除
                </el-link>
                <el-dropdown trigger='click' class='user-name'>
                  <el-link type='primary' style='margin-left:12px'>
                    更多
                  </el-link>
                  <el-dropdown-menu slot='dropdown'>
                    <el-dropdown-item>
                      <span onClick={() => this.contDialogOpen(row)}>课程内容</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <span onClick={() => this.coursePreview(row)}>课程预览</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            );
          } else if (row.examineStatus == 3) {
            return (
              <div>
                <el-link type='primary' onClick={() => this.doEdit(row)}>
                  编辑
                </el-link>
                <el-link type='danger' style='margin-left:12px' onClick={() => this.doDelete(row)}>
                  删除
                </el-link>
                <el-dropdown trigger='click' class='user-name'>
                  <el-link type='primary' style='margin-left:12px'>
                    更多
                  </el-link>
                  <el-dropdown-menu slot='dropdown'>
                    <el-dropdown-item>
                      <span onClick={() => this.contDialogOpen(row)}>课程内容</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <span onClick={() => this.coursePreview(row)}>课程预览</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            );
          }
        },
      },
    ];
    this.getList();
  },
  methods: {
    // 新增
    addCourse() {
      this.courseForm = {};
      this.$refs.projectDialog.addVisible = true;
    },

    // 分页
    onCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },

    // 编辑
    doEdit(obj) {
      this.dialogTitle = '编辑课程';
      this.courseForm = obj;

      getCourseInfo(
        encrypt(
          JSON.stringify({
            id: obj.id,
          }),
        ),
      ).then((res) => {
        this.courseForm = JSON.parse(decrypt(res.data));
        this.courseForm.labelName = this.labelList.filter((item) => new Set(JSON.parse(this.courseForm.labelName)).has(item.labelName)).map((item) => item.labelId);

        this.courseForm.userType = this.courseForm.userType.split(',');

        this.courseForm.systemType = this.courseForm.systemType.split(',');

        console.log('courseForm 112233:>> ', this.courseForm);


        //     e.recommendId = e.id;
        //     delete e['id']
        // }
        // this.courseForm.articleRecommend = this.courseForm.articleList;
      });
      this.$refs.projectDialog.addVisible = true;
    },
    // 删除
    doDelete(row) {
      this.$confirm(`确认要删除此课程吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let info = {
          id: row.id,
          isDelete: row.isDelete == 1 ? 0 : 1,
        };
        console.log(info);
        var data = encrypt(JSON.stringify(info));
        courseDelete(data).then((res) => {
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success',
          });
          this.getList();
        });
      });
    },
    subReview(row) {
      this.$confirm(`确认要提交审批吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let info = {
          id: row.id,
          examineStatus: 1,
        };
        console.log(info);
        var data = encrypt(JSON.stringify(info));
        courseExamine(data).then((res) => {
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success',
          });
          this.getList();
        });
      });
    },
    // 上线/下线
    coursePublish(row) {
      let msg = '';
      if (row.publishStatus == 1) {
        msg = '下线后，推广位中该课程将不展示，是否下线？';
      } else {
        msg = '确认要发布此课程吗?';
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let info = {
          id: row.id,
          publishStatus: row.publishStatus == 1 ? 2 : 1,
        };
        console.log(info);
        var data = encrypt(JSON.stringify(info));
        coursePublish(data).then((res) => {
          if (res.result == 1) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'warning',
            });
          }
          this.getList();
        });
      });
    },

    getList(searchForm) {
      if (searchForm) {
        this.pageNum = 1;
        this.searchForm = searchForm;
      }
      this.tableLoading = true;
      let info = {
        page: this.pageNum,
        pageSize: this.pageSize,
        queryType: 2,
        type: 2,
        ...this.searchForm,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));

      getCourseList(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          this.total = ress.total;
          this.pageNum = ress.pageNum;
          this.courseList = ress.list;
          this.tableLoading = false;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },

    coursePreview(row) {
      console.log('课程预览 :>> ');
      this.$refs.projectContent.previewDialogOpen(row);
    },

    contDialogOpen(row) {
      this.$refs.projectContent.contDialogOpen(row);
    },
  },
};
</script>
<style scoped>
/* 图片容器居中显示 */
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  height: 180px;
  overflow: hidden;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}
</style>
